/**
 * The docs page's one script (L14a R748): marks, in the table of contents, the section or tool
 * being read. Without it the contents are plain links and the page reads the same.
 */

const links = new Map<string, HTMLAnchorElement>();
for (const link of document.querySelectorAll<HTMLAnchorElement>(".toc a[href^='#']")) {
  links.set(link.hash.slice(1), link);
}

const mark = (id: string): void => {
  for (const [key, link] of links) link.setAttribute("aria-current", String(key === id));
};

const targets = [...links.keys()]
  .map((id) => document.getElementById(id))
  .filter((element): element is HTMLElement => element !== null);

// The last target whose top has passed the line under the sticky nav is the one being read.
const update = (): void => {
  const passed = targets.filter((element) => element.getBoundingClientRect().top <= 96);
  mark((passed.at(-1) ?? targets[0])?.id ?? "");
};

addEventListener("scroll", update, { passive: true });
addEventListener("hashchange", update);
update();
